import { Button } from '@did/das-balance-components'
import { FIAT_DECIMAL_PLACES } from '@did/das-balance-constants'
import { useDasBalanceContext } from '@did/das-app-context'
import { AvailableBalanceType } from '@did/das-balance-types'
import { cn, thousandSplit } from '@did/tools'
import React, { useMemo } from 'react'

export const AvailableBalance: AvailableBalanceType = ({
  className,
  onSendClick,
  onReceiveClick,
  ActivateInfo,
  availableBalance,
  balanceUSD,
  transitBalance
}) => {
  const { tt } = useDasBalanceContext()

  const showActivateInfo = useMemo(() => {
    return transitBalance !== '0' && transitBalance && ActivateInfo
  }, [transitBalance, ActivateInfo])

  return (
    <div className={` ${className}`}>
      <div className="flex flex-col items-center">
        {showActivateInfo && ActivateInfo && transitBalance && (
          <ActivateInfo
            transitBalance={transitBalance}
            className=" flex justify-between items-center rounded-xl bg-red-100 pl-3 pr-1 py-1 text-sm text-red-600 font-bold mb-4 "
          />
        )}
        <div
          className={cn(
            "text-4xl text-primary font-['Barlow-Medium']",
            !showActivateInfo && 'mt-8'
          )}
        >
          {thousandSplit(availableBalance, FIAT_DECIMAL_PLACES)}{' '}
          <span className="text-gray-350">CKB</span>
        </div>
        <div className="mt-1 text-gray-500 mb-8  ">
          ${thousandSplit(balanceUSD)}
        </div>
      </div>
      <div className=" flex items-center">
        <Button className="mr-4" middle black block onClick={onReceiveClick}>
          {tt('Receive')}
        </Button>
        <Button middle block onClick={onSendClick}>
          {tt('Send')}
        </Button>
      </div>
    </div>
  )
}

export default AvailableBalance
